import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LKHeader } from '@/widgets/LKHeader';
import { useUserStore } from '@/entities/User';
import { UserInfo } from '@/features/LK/UserInfo';
import { BackButton } from '@/features/LK/BackButton';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import { usePrepareLayout } from '@/shared/lib/hooks/usePrepareLayout';
import cls from './UserProfile.module.scss';

export const UserProfile = () => {
    const { isAuth } = useUserStore();

    const navigate = useNavigate();

    usePrepareLayout();

    useEffect(() => {
        if (!isAuth) {
            navigate('/lk/');
        }
    }, []);

    const width = useResize();

    return (
        <div className={cls.container}>
            {width >= 768 && <LKHeader hideUserControls />}

            <BackButton
                className={cls.backButton}
                onClick={() => {
                    navigate('/lk');
                }}
            />
            <UserInfo />
        </div>
    );
};
